import axios from 'axios';
import { getUser } from './storage';

//export const URL = "http://127.0.0.1:8000"
//export const URL = "http://192.168.11.150:8000"
//export const URL = "https://wilofo-api.enumera.tech"
export const URL = process.env.REACT_APP_API_URL || "http://localhost:8080"
console.log(URL);

//export const URL = "https://wilofo-api.enumera.tech";
//export const URL = "https://api.enumera.tech"

const request = axios.create({
    baseURL: URL+"/api/",
    withCredentials: false,
    headers: {
        'Accept':'application/json',
        'Content-Type': 'application/json'
    },
});

// Interceptor pour ajouter automatiquement le token d'authentification
request.interceptors.request.use(
    (config) => {
        const user = getUser();
        if (user && user.token) {
            config.headers.Authorization = `Bearer ${user.token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor pour gérer les erreurs d'authentification
request.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            // Token expiré ou invalide
            console.error('Token d\'authentification invalide ou expiré');
            // Vous pouvez rediriger vers la page de connexion ici
            // window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default request